import { map } from 'ramda';
import React, { FC } from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import FlexColumn from '@ui/atoms/FlexColumn';
import FlexRow from '@ui/atoms/FlexRow';

import RoundedCard from '@ui/molecules/RoundedCard';

import aligned from '@ui/styled/Aligned';

import { exists } from '@utils/general';

import { ColorTypes } from '@folx-types/theme';

import bullet from '@assets/vectors/star-bullet.svg';

interface IMembershipCardProps {
	header: string;
	topics: { info: string }[];
	bgColor?: ColorTypes;
}

const Bullet = styled.img.attrs({
	src: bullet,
})`
	margin-top: 0.4rem;
	width: 1.6rem;
	height: 1.6rem;
`;

const AlignedRow = aligned(FlexRow);

const MembershipCard: FC<IMembershipCardProps> = ({
	bgColor = 'lightLavender',
	header,
	topics,
}) => {
	return (
		<RoundedCard bgColor={bgColor}>
			<FlexColumn gap="sm">
				{exists(header) && <BasicText variant="small">{header}</BasicText>}
				{map(
					(topic) => (
						<AlignedRow alignItems="flex-start" gap="xs" key={topic.info}>
							<Bullet alt="Bullet Point" />
							<BasicText>{topic.info}</BasicText>
						</AlignedRow>
					),
					topics
				)}
			</FlexColumn>
		</RoundedCard>
	);
};

export default styled(MembershipCard)``;
